import { request } from '../api/http-library';
import { external_address } from '../../../../public-config';

// action requested is either signup or login
// source is intended to be the analytic for where they came from - "nav"
// callback should take an error message - only in case of not making it to 
// apple redirect
const appleConnect = {
  getCode: (actionRequested, source, errorCallback) => {
    const requestParams = {
      host: external_address,
      method: 'POST',
      path: '/apple-connect'
    };

    const requestBody = {
      source,
      actionRequested,
      reqFromPath: location.hash
    };

    request(requestParams, (response) => {
      const {
        error,
        stateCode,
        clientId
      } = response;

      if (response.error) {
        if ('function' === typeof(errorCallback)) {
          return errorCallback(response.error);
        }
      }
      const redirectURI = `https://${external_address}/apple-connect/response`;
      const responseType = 'code id_token';
      const responseMode = 'form_post';
      const scope = 'email name';
      const query = `?client_id=${clientId}&redirect_uri=${redirectURI}&response_mode=${responseMode}&response_type=${responseType}&scope=${scope}&state=${stateCode}`;
      location.href = `https://appleid.apple.com/auth/authorize${query}`;
    }, requestBody);
  }
};

export default appleConnect;
